module.exports = __webpack_public_path__ + "static/media/  (22).6865674b.jpg";